/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { ReactNode } from 'react';
import type { SnippetsSectionProps } from '../Snippets/types';
import { Text } from './Text';
import { SnippetsSection } from '../Snippets/SnippetsSection';
import { IssueTrackerLink } from '../../IssueTrackerLink/IssueTrackerLink';
import { SkeletonLoader } from '../SkeletonLoader/SkeletonLoader';
import { SECTION_NAME_FEEDBACK } from '../../../constants/snippetsSectionNames';

export function Feedback( { number, isLoading }: SnippetsSectionProps ): ReactNode {
	return (
		<SkeletonLoader number={ number } sectionTitle={ SECTION_NAME_FEEDBACK } isLoading={ isLoading }>
			<SnippetsSection
				headerCharacter={ number }
				title={ SECTION_NAME_FEEDBACK }
				hideHorizontalLine={ true }
			>
				<Text>
					If you encountered any difficulties or have suggestions for improvement,
					please <IssueTrackerLink useTemplate={ false }>file an issue</IssueTrackerLink> in our GitHub repository.
				</Text>
			</SnippetsSection>
		</SkeletonLoader>
	);
}
